// extracted by mini-css-extract-plugin
export default {"inner":"HintedContent_inner__OC3Hs","wrap":"HintedContent_wrap__QDPtw"};